import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl } from '@angular/forms';

import { AnjunaValidators } from '../models/AnjunaValidators';
import { RequiredCheckResult } from '../interfaces/RequiredCheckResult';

/* tslint:disable:directive-selector */
@Directive({
    selector: 'anj-checkbox[required][ngModel], anj-toggle[required][ngModel]',
    providers: [
        {provide: NG_VALIDATORS, useExisting: RequiredCheckDirective, multi: true}
    ]
})
export class RequiredCheckDirective implements Validator {

    public validate(c: FormControl): RequiredCheckResult {
        return AnjunaValidators.requiredCheck(c);
    }

}
